import React from 'react'
import {request} from '../../helpers/request.js';
import CurrencyComponent from './CurrencyComponent'
import {makeGrids} from '../../helpers/makeGrids'
import {getPaymentProviderName} from '../../helpers/getPaymentProviderName'
import {ButtonGroup, ButtonToolbar, Collapse, Fade, ListGroup, ListGroupItem, Alert, Input, Panel} from 'react-bootstrap'
import _ from 'lodash'
import Icon from 'react-fa'
import accounting from 'accounting'
import {t} from '../../helpers/translate'
import PaymentHistoryComponent from './PaymentHistoryComponent'
import StaticTextComponent from './StaticTextComponent';
import {formatMoney} from '../../helpers/formatMoney';
let config = require('config');

class InvoiceComponent extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      paymentResponse: null,
      processingPayment: false
    }
  }

  processPayment() {
    this.setState({
      processingPayment: true
    }, () => {
      this.props.onPaymentSuccess({
        payment_provider: 'invoice'
      });
    });
  }

  cancelPayment() {
    this.setState({
      processingPayment: false
    }, this.props.onCancel);
  }

  render() {
    return (
      <div>
      {
          this.props.quoteResponseData ?
            <div className="form-group">
            <label className="text-uppercase">{t('Charge')}</label>
            <StaticTextComponent value={formatMoney(this.props.quoteResponseData.premium_difference, this.props.quoteResponseData.currency)}/>
            </div>
            : null
      }
      {
        this.props.quoteResponseData && this.props.quoteResponseData.premium_difference > 0 ?
          <div className="btn-group pull-left">
            <button className="btn button-primary"
                    onClick={this.cancelPayment.bind(this)}
                    disabled={this.props.paymentSuccessful !== false && (this.state.processingPayment || !this.props.quoteResponseData)}>
              {t('Cancel')}
            </button>
            <button className="btn button-secondary"
                    onClick={this.processPayment.bind(this)}
                    disabled={this.props.paymentSuccessful !== false && (this.state.processingPayment || !this.props.quoteResponseData)}
                    bsStyle={this.props.paymentSuccessful ? 'success' : 'primary'}>
              {this.props.paymentSuccessful !== false && (this.state.processingPayment || !this.props.quoteResponseData)  ? <Icon spin name="spinner"/> : null}
              {' '}
              {this.props.paymentSuccessful === true ?
                [<Icon name="check"/>, <span>{ t('Update Successful')}</span>] : t('Update Policy')}
            </button>
          </div> : null
      }
      </div>
    )
  }
}

InvoiceComponent.displayName = 'InvoiceComponent';
export default InvoiceComponent;



// WEBPACK FOOTER //
// ./src/components/common/InvoiceComponent.js